import React from 'react';
import { Group, Slider, Text } from '@mantine/core';
import {
  APPEAR_ANIMATION_DURATION_MAX_MS,
  APPEAR_ANIMATION_DURATION_MIN_MS,
  APPEAR_ANIMATION_DURATION_STEP_MS,
  APPEAR_ANIMATION_NONE,
  APPEAR_ANIMATION_OPTIONS,
  normalizeAppearAnimation,
  normalizeAppearAnimationDuration,
} from '../../utils/appearAnimations';
import InspectorRow from './InspectorRow';
import { useSelectedItemProps } from './useSelectedItemProps';
import styles from './AppearAnimationField.module.css';

const VARIANT_CLASS = {
  none: '',
  fade: styles.demoFade,
  'slide-up': styles.demoSlideUp,
  zoom: styles.demoZoom,
};

/**
 * Champ animation d'apparition : cartes cliquables (aperçu en boucle CSS
 * pure au survol/focus — voir AppearAnimationField.module.css). La vitesse,
 * réglage rare, est un champ à part dans « Réglages avancés »
 * (puckAppearAnimationDurationField).
 */
export default function AppearAnimationField({ value, onChange, label }) {
  const current = normalizeAppearAnimation(value);

  return (
    <InspectorRow label={label} layout="stacked">
      <div className={styles.grid} role="listbox" aria-label={label || "Animation d'apparition"}>
        {APPEAR_ANIMATION_OPTIONS.map((opt) => {
          const selected = current === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              role="option"
              aria-selected={selected}
              title={opt.label}
              className={`${styles.card} ${selected ? styles.cardSelected : ''}`}
              onClick={() => onChange(opt.value)}
            >
              <div className={styles.demoViewport}>
                <div className={`${styles.demoBlock} ${VARIANT_CLASS[opt.value]}`} />
              </div>
              <Text size="10px" c={selected ? 'editor.7' : 'dimmed'} lh={1.2} ta="center">
                {opt.label}
              </Text>
            </button>
          );
        })}
      </div>
    </InspectorRow>
  );
}

/** Vitesse d'apparition : sans animation choisie, elle n'a rien à régler. */
function AppearAnimationDurationField({ value, onChange }) {
  const { itemProps } = useSelectedItemProps();
  const hasAnimation = normalizeAppearAnimation(itemProps.appearAnimation) !== APPEAR_ANIMATION_NONE;

  return (
    <InspectorRow
      label="Vitesse d'apparition"
      layout="stacked"
      description={hasAnimation ? null : 'Choisissez d’abord une animation d’apparition.'}
    >
      <Slider
        size="sm"
        disabled={!hasAnimation}
        min={APPEAR_ANIMATION_DURATION_MIN_MS}
        max={APPEAR_ANIMATION_DURATION_MAX_MS}
        step={APPEAR_ANIMATION_DURATION_STEP_MS}
        value={normalizeAppearAnimationDuration(value)}
        onChange={onChange}
        label={(v) => `${v} ms`}
      />
      <Group justify="space-between" mt={4}>
        <Text size="10px" c="dimmed">Rapide</Text>
        <Text size="10px" c="dimmed">Lente</Text>
      </Group>
    </InspectorRow>
  );
}

export function puckAppearAnimationDurationField() {
  return {
    type: 'custom',
    label: "Vitesse d'apparition",
    render: (props) => <AppearAnimationDurationField {...props} />,
  };
}
